<template>
  <div>
    <div class="table-page-search-wrapper">
      <a-form-model :layout="isMobile() ? '' : 'inline'" @keyup.enter.native="$emit('searchQuery')">
        <a-row :gutter="24">
          <a-col
            :xs="24"
            :sm="24"
            :md="12"
            :lg="8"
            :xl="6"
            :xxl="4"
            v-if="
              XEUtils.includes(
                [
                  'TaskManage',
                  'RuntimeModal',
                  'HistoryModal',
                  'CcMeRuntimeModal',
                  'CcMeHistoryModal',
                  'AdminRuntimeModal',
                  'AdminHistoryModal',
                  'AdminUnactiveModal',
                ],
                parent
              )
            "
          >
            <a-form-model-item :label="'　' + $t('disp.flow.starter')">
              <a-input placeholder="申请人模糊查询" v-model="queryParam.startUserName"></a-input>
            </a-form-model-item>
          </a-col>

          <a-col
            :xs="24"
            :sm="24"
            :md="12"
            :lg="8"
            :xl="6"
            :xxl="4"
            v-if="
              XEUtils.includes(
                [
                  'TaskManage',
                  'RuntimeModal',
                  'HistoryModal',
                  'CcMeRuntimeModal',
                  'CcMeHistoryModal',
                  'AdminRuntimeModal',
                  'AdminHistoryModal',
                  'AdminUnactiveModal',
                ],
                parent
              )
            "
          >
            <a-form-model-item :label="$t('disp.flow.starterOrg')">
              <j-input-popup
                v-model="departIds"
                component="SelectDepartTreeModal"
                :placeholder="this.$t('disp.ph.select', [$t('disp.flow.starterOrg')])"
                :params="{ companyId: '', departName: '', multiFlg: '1', departFlg: '1', searchFlg: '0' }"
                @change="handleDeptChange"
              ></j-input-popup>
            </a-form-model-item>
          </a-col>

          <a-col
            :xs="24"
            :sm="24"
            :md="12"
            :lg="8"
            :xl="6"
            :xxl="4"
            v-if="
              XEUtils.includes(
                ['TaskManage', 'HistoryModal', 'CcMeHistoryModal', 'AdminHistoryModal', 'AdminUnactiveModal'],
                parent
              )
            "
          >
            <a-form-model-item label="申请时间">
              <a-date-picker v-model="queryParam.startDate" placeholder="请选择申请时间" style="width: 100%" />
            </a-form-model-item>
          </a-col>

          <a-col
            :xs="24"
            :sm="24"
            :md="12"
            :lg="8"
            :xl="6"
            :xxl="4"
            v-if="
              XEUtils.includes(
                ['TaskManage', 'HistoryModal', 'CcMeHistoryModal', 'AdminHistoryModal', 'AdminUnactiveModal'],
                parent
              )
            "
          >
            <a-form-model-item label="更新时间">
              <a-date-picker v-model="queryParam.endDate" placeholder="请选择更新时间" style="width: 100%" />
            </a-form-model-item>
          </a-col>

          <a-col
            :xs="24"
            :sm="24"
            :md="12"
            :lg="8"
            :xl="6"
            :xxl="4"
            v-if="XEUtils.includes(['RuntimeModal', 'CcMeRuntimeModal', 'AdminRuntimeModal'], parent)"
          >
            <a-form-model-item label="当前任务">
              <a-input placeholder="当前任务模糊查询" v-model="queryParam.taskName"></a-input>
            </a-form-model-item>
          </a-col>

          <a-col
            :xs="24"
            :sm="24"
            :md="12"
            :lg="8"
            :xl="6"
            :xxl="4"
            v-if="XEUtils.includes(['RuntimeModal', 'CcMeRuntimeModal', 'AdminRuntimeModal'], parent)"
          >
            <a-form-model-item :label="'　' + '审批人'">
              <a-input placeholder="审批人模糊查询" v-model="queryParam.candidateName"></a-input>
            </a-form-model-item>
          </a-col>

          <a-col
            :xs="0"
            :sm="0"
            :md="0"
            :lg="0"
            :xl="0"
            :xxl="8"
            v-if="
              XEUtils.includes(
                [
                  'TaskManage',
                  'RuntimeModal',
                  'HistoryModal',
                  'CcMeRuntimeModal',
                  'CcMeHistoryModal',
                  'AdminRuntimeModal',
                  'AdminHistoryModal',
                  'AdminUnactiveModal',
                ],
                parent
              )
            "
          >
            <a-form-model-item>
              <span></span>
            </a-form-model-item>
          </a-col>

          <a-col
            :xs="24"
            :sm="24"
            :md="12"
            :lg="8"
            :xl="6"
            :xxl="4"
            v-if="
              XEUtils.includes(
                [
                  'TaskManage',
                  'RuntimeModal',
                  'HistoryModal',
                  'CcMeRuntimeModal',
                  'CcMeHistoryModal',
                  'AdminRuntimeModal',
                  'AdminHistoryModal',
                  'AdminUnactiveModal',
                ],
                parent
              )
            "
          >
            <a-form-model-item label="流程编号">
              <a-input placeholder="请填写流程编号" v-model="queryParam.processInstanceId"></a-input>
            </a-form-model-item>
          </a-col>

          <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item :label="$t('disp.flow.applyName')">
              <a-select
                mode="combobox"
                :showSearch="true"
                :showArrow="false"
                style="width: 100%"
                :getPopupContainer="(target) => target.closest('.app-body')"
                placeholder="流程名称模糊查询"
                v-model="queryParam.processDefinitionName"
              >
                <a-select-opt-group v-for="(group, index) in applyNameListGroup" :key="index">
                  <span slot="label">
                    <span
                      class="mdi mdi-rhombus-split"
                      style="color: var(--color-primary-5); font-size: 12px; position: relative; top: -1px"
                    ></span>
                    {{ $getDict('wf_type', group[0].wfType) }}</span
                  >
                  <a-select-option v-for="item in group" :key="item.describe">
                    <span style="margin-left: 10px">{{ item.describe }}</span>
                  </a-select-option>
                </a-select-opt-group>
              </a-select>
            </a-form-model-item>
          </a-col>

          <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="流程摘要">
              <a-input placeholder="流程摘要模糊查询" v-model="queryParam.summary"></a-input>
            </a-form-model-item>
          </a-col>

          <a-col
            :xs="24"
            :sm="24"
            :md="12"
            :lg="8"
            :xl="6"
            :xxl="4"
            v-if="
              XEUtils.includes(
                [
                  'TaskManage',
                  'RuntimeModal',
                  'HistoryModal',
                  'CcMeRuntimeModal',
                  'CcMeHistoryModal',
                  'AdminRuntimeModal',
                  'AdminHistoryModal',
                  'AdminUnactiveModal',
                ],
                parent
              )
            "
          >
            <a-form-model-item label="流程状态">
              <j-dict-select-tag
                v-if="statusType == '0'"
                v-model="queryParam.status"
                dictCode="flow_status_runtime"
                placeholder="请选择流程状态"
              />
              <j-dict-select-tag
                v-if="statusType == '1'"
                v-model="queryParam.status"
                dictCode="flow_status_history"
                placeholder="请选择流程状态"
              />
            </a-form-model-item>
          </a-col>

          <a-col :xs="1" :sm="1" class="width-fit-content">
            <a-form-model-item class="width-fit-content">
              <a-button
                type="primary"
                @click="
                  () => {
                    getWfTypeCount()
                    $emit('searchQuery')
                  }
                "
                icon="search"
                >{{ this.$t('disp.btn.search') }}</a-button
              >

              <a-button @click="searchReset" icon="stop">{{ this.$t('disp.btn.reset') }}</a-button>

              <a-divider
                type="vertical"
                v-if="
                  XEUtils.includes(['AdminRuntimeModal'], parent) ||
                  (XEUtils.includes(['AdminHistoryModal'], parent) && $getLoginUser().editableFlag == '1')
                "
              ></a-divider>

              <a-button
                type="primary"
                @click="$emit('handleExport')"
                icon="cloud-download"
                v-if="
                  XEUtils.includes(['AdminRuntimeModal'], parent) ||
                  (XEUtils.includes(['AdminHistoryModal'], parent) && $getLoginUser().editableFlag == '1')
                "
                >导出</a-button
              >

              <!--<template v-if="batchType == '3' && $getLoginUser().editableFlag == '1'">
              <a-button type="primary" @click="$emit('addTaskIdentity')">添加Identity</a-button>
            </template>-->

              <!--<template v-if="batchType == '3' && $getLoginUser().editableFlag == '1'">
              <a-button type="primary" @click="$emit('addTaskVariableLocal')">添加流程变量(会签任务)</a-button>
            </template>-->

              <!-- 0:未処理一覧 1:処理済一覧 2:一時保存 3:申請案件の未処理タブ 4:申請案件の非活性タブ 5:事務系画面 -->
              <a-dropdown v-if="this.rowKeySize > 0 && this.batchType != '2'">
                <a-menu slot="overlay">
                  <a-menu-item key="approve" v-if="this.batchType == '0'" @click="batchAction('approve')">
                    <a-icon type="check" />
                    {{ this.$t('disp.flow.approveBatch') }}
                  </a-menu-item>
                  <a-menu-item key="refuse" v-if="this.batchType == '0'" @click="batchAction('refuse')">
                    <a-icon type="close" />
                    {{ this.$t('disp.flow.refuseBatch') }}
                  </a-menu-item>
                  <a-menu-item key="appoint" v-if="this.batchType == '0'" @click="batchAction('appoint')">
                    <a-icon type="user-add" />
                    {{ '批量委派' }}
                  </a-menu-item>
                  <a-menu-item key="pullback" v-if="this.batchType == '1'" @click="batchAction('pullback')">
                    <a-icon type="arrow-left" />
                    {{ this.$t('disp.flow.pullbackBatch') }}
                  </a-menu-item>
                  <a-menu-item key="freeze" v-if="this.batchType == '3'" @click="batchAction('freeze')">
                    <a-icon type="clock-circle" />
                    {{ this.$t('disp.btn.frozenBatch') }}
                  </a-menu-item>
                  <a-menu-item key="unfreeze" v-if="this.batchType == '3'" @click="batchAction('unfreeze')">
                    <a-icon type="check-circle" />
                    {{ this.$t('disp.btn.unFrozenBatch') }}
                  </a-menu-item>
                  <a-menu-item key="candidateAdd" v-if="this.batchType == '4'" @click="batchAction('candidateAdd')">
                    <a-icon type="plus-circle" />
                    {{ this.$t('disp.flow.candidateAddBatch') }}
                  </a-menu-item>
                  <a-menu-item
                    key="cancel"
                    v-if="
                      this.batchType == '0' || this.batchType == '1' || this.batchType == '3' || this.batchType == '4'
                    "
                    @click="batchAction('cancel', batchType)"
                  >
                    <a-icon type="undo" />
                    {{ this.$t('disp.flow.cancelBatch') }}
                  </a-menu-item>
                  <a-menu-item key="keep" v-if="this.batchType == '0'" @click="batchAction('keep')">
                    <a-icon type="lock" />
                    {{ this.$t('disp.flow.keepBatch') }}
                  </a-menu-item>
                  <a-menu-item
                    key="keepCancel"
                    v-if="this.batchType == '0' || this.batchType == '3'"
                    @click="batchAction('keepCancel')"
                  >
                    <a-icon type="unlock" />
                    {{ this.$t('disp.flow.keepCancelBatch') }}
                  </a-menu-item>
                </a-menu>
                <a-button>
                  {{ $t('disp.btn.operationBatch') }}
                  <a-icon type="down" />
                </a-button>
              </a-dropdown>
              <a-button
                v-if="this.rowKeySize > 0 && this.batchType == '2'"
                @click="batchAction('cancel', batchType)"
                icon="undo"
                >{{ this.$t('disp.flow.cancelBatch') }}</a-button
              >
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </div>

    <div v-if="XEUtils.includes(['TaskManage'], parent)">
      <div
        style="margin-bottom: 4px; font-size: 14px; color: black; display: inline-block; position: relative; top: 1px"
      >
        <JSharp style="margin-left: 1px; position: relative; top: -1px"></JSharp>
        <span>按分类筛选：</span>
      </div>

      <div class="div-flow-filter">
        <div class="category" :class="queryParam.wfType == '' ? 'active' : ''" @click="changeWfType('')">
          <span>全部</span>
          <span class="num" :style="XEUtils.sum(wfTypeCounts, 'count') == 0 ? 'color: var(--color-grey)' : ''"
            >（{{ XEUtils.sum(wfTypeCounts, 'count') }}）</span
          >
        </div>
        <div
          @click="changeWfType(wfTypeCount.wfType)"
          class="category"
          :class="queryParam.wfType == wfTypeCount.wfType ? 'active' : ''"
          v-for="wfTypeCount in wfTypeCounts"
          :key="wfTypeCount.wfType"
        >
          <span>{{ wfTypeCount.wfTypeName }}</span>
          <span class="num" :style="wfTypeCount.count == 0 ? 'color: var(--color-grey)' : ''"
            >（{{ wfTypeCount.count }}）</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { httpAction, getAction, postAction } from '@/api/manage'
import JDictSelectTag from '@/components/dict/JDictSelectTag.vue'
import JInputPopup from '@/components/JInputPopup'
import moment from 'moment'
import { mixin, mixinDevice } from '@/utils/mixin.js'

export default {
  name: 'SearchArea',
  mixins: [mixin, mixinDevice],
  components: {
    JDictSelectTag,
    JInputPopup,
  },
  props: {
    parent: '',
    // 0:未完成 1:終了済 2:一時保存
    statusType: {
      type: String,
      default: '0',
    },
    // 選択行の数量
    rowKeySize: {
      type: Number,
      default: 0,
    },
    // 0:未処理一覧 1:処理済一覧 2:一時保存 3:申請案件の未処理タブ 4:申請案件の非活性タブ 5:事務系画面
    batchType: {
      type: String,
      default: '0',
    },
  },
  data() {
    return {
      description: 'ワークフロー共通検索部',
      // 検索条件
      queryParam: {
        startUserName: '',
        startOrgIds: '',
        candidateName: '',
        startDate: '',
        endDate: '',
        taskName: '',
        processInstanceId: '',
        processDefinitionName: '',
        summary: '',
        status: '',
        wfType: '',
      },
      // 申請名称一覧
      applyNameList: [],
      applyNameListGroup: [],
      departIds: [],
      wfTypeCounts: [],
    }
  },
  created() {
    this.getWfTypeCount()

    if (sessionStorage['LOGIN_USER_BUTTON_AUTH']) {
      this.applyNameList = XEUtils.filter(
        JSON.parse(sessionStorage['LOGIN_USER_BUTTON_AUTH']),
        (item) => item.action.indexOf('flow:model:') == 0
      )
      this.applyNameListGroup = XEUtils.groupBy(this.applyNameList, 'wfType')
    }
  },
  computed: {},
  watch: {
    queryParam: {
      handler(newVal, oldVal) {
        this.getWfTypeCount()
        this.$emit('updateQueryParam', this.queryParam)
      },
      immediate: false,
      deep: true,
    },
  },
  methods: {
    searchReset: function () {
      this.departIds = []
      this.queryParam = {
        startUserName: '',
        startOrgIds: '',
        candidateName: '',
        startDate: '',
        endDate: '',
        taskName: '',
        processInstanceId: '',
        processDefinitionName: '',
        summary: '',
        status: '',
        wfType: '',
      }
    },
    batchAction: function (key, batchType) {
      this.$emit('batchAction', key, batchType)
    },
    handleDeptChange: function () {
      this.queryParam.startOrgIds = XEUtils.map(this.departIds, (item) => item.id).join(',')
    },
    getWfTypeCount: function () {
      if (XEUtils.includes(['TaskManage'], this.parent)) {
        this.queryParam.parent = this.parent

        getAction('/flow/getWfTypeCount', this.queryParam)
          .then((res) => {
            if (res.success) {
              this.wfTypeCounts = res.result

              var dictItems = JSON.parse(sessionStorage['dictCode_wf_type'])

              this.wfTypeCounts.forEach((r) => {
                var dictItem = XEUtils.first(XEUtils.filter(dictItems, (d) => d.value == r.wfType))
                r.wfTypeName = dictItem.text
                r.sortOrder = dictItem.sortOrder
              })

              this.wfTypeCounts = XEUtils.orderBy(this.wfTypeCounts, [['sortOrder', 'asc']])
            }
          })
          .finally(() => {})
      }
    },
    changeWfType(selected) {
      if (this.queryParam.wfType != selected) {
        this.queryParam.wfType = selected
      }
    },
  },
}
</script>
<style lang="less" scoped>
.div-flow-filter {
  display: inline-block;

  .category {
    display: inline-block;
    //background: #f8f8f8;
    padding: 5px 4px 5px 11px;
    font-size: 14px;
    margin-right: 8px;
    margin-bottom: 8px;
    border-radius: 6px;
    cursor: pointer;
    //min-width: 100px;
    text-align: center;
    transition: all 0.3s;
    color: #000;
    background: #f8f8f8;

    &.active {
      color: var(--color-primary-6);
      background: var(--color-primary-1);

      //.num {
      //  color: green !important;
      //}
    }

    &:hover {
      background: var(--color-primary-1);
    }

    .num {
      color: var(--color-green-6);
      font-size: 13px;
      position: relative;
      letter-spacing: 0px;
    }
  }
}
</style>
